RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.ButtonGroup = Marionette.CompositeView.extend({
        template: '#shellToolbarButtonGroupTemplate',
        childView: views.ToolbarButton,
        childViewEventPrefix: 'buttonGroup',
        childViewContainer: '.x-child-region',

        serializeData: function () {
            const me = this;
            return {
                label: me.getOption('label')
            };
        },

        childViewOptions: {
            hideLinkIcon: true
        },

        onButtonGroupAction: function (view) {
            const me = this;
            const model = view.model;

            if (model.get('active')) {

                return;
            }

            const active = me.collection.findWhere({
                active: true
            });

            if (active) {

                active.set({
                    active: false
                });
            }

            model.set({
                active: true
            });
            me.triggerMethod('toolbar:action', model, me.getOption('name'));
        }
    });

    views.ButtonGroup.getItemViewOptionsFromConfig = function (config) {
        const collection = new Backbone.Collection(config.items);
        return _.extend({
            collection: collection
        }, _.pick(config, 'align', 'size', 'name', 'label'));
    };
});
